'use strict';
var vjs = require('video.js');

var services = {
    facebook: {
        text: 'Facebook',
        link: 'https://www.facebook.com/sharer/sharer.php?u={url}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#3B5898\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#FFFFFF\" d=\"M39.4,29.4l0.9-7.2h-7.2v-4.6c0-2.1,0.6-3.5,3.6-3.5h3.8V7.5c-0.7-0.1-2.9-0.3-5.6-0.3 c-5.5,0-9.3,3.4-9.3,9.6v5.3h-6.3v7.2h6.3V48h7.5V29.4H39.4z\"></path>\n</svg>\n",
        popup: {width: 560, height: 610},
    },
    twitter: {
        text: 'Twitter',
        link: 'https://twitter.com/intent/tweet?url={url}&text={title}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#55ACEE\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#FFFFFF\" d=\"M40,14.1c-1.2,0.5-2.4,0.9-3.8,1c1.4-0.8,2.4-2.1,2.9-3.6c-1.3,0.8-2.7,1.3-4.2,1.6 C33.8,11.8,32,11,30.2,11c-3.6,0-6.6,2.9-6.6,6.6c0,0.5,0.1,1,0.2,1.5c-5.5-0.3-10.3-2.9-13.5-6.9c-0.6,1-0.9,2.1-0.9,3.3 c0,2.3,1.2,4.3,2.9,5.5c-1.1,0-2.1-0.3-3-0.8v0.1c0,3.2,2.3,5.8,5.3,6.4c-0.6,0.1-1.1,0.2-1.7,0.2c-0.4,0-0.8,0-1.2-0.1 c0.8,2.6,3.3,4.5,6.1,4.6c-2.2,1.8-5.1,2.8-8.2,2.8c-0.5,0-1.1,0-1.6-0.1C10.9,36,14.4,37,18.1,37c12.1,0,18.7-10,18.7-18.7 c0-0.3,0-0.6,0-0.8C38,16.6,39.1,15.4,40,14.1z\"></path>\n</svg>\n",
        popup: {width: 500, height: 260},
    },
    'google+': {
        text: 'Google+',
        link: 'https://plus.google.com/share?url={url}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#DB4437\" width=\"100%\" height=\"100%\"></rect>\n  <polyline fill=\"#FFFFFF\" points=\"42.1,21.8 37.7,21.8 37.7,17.4 34.4,17.4 34.4,21.8 30,21.8 30,25.1 34.4,25.1 34.4,29.5 37.7,29.5 37.7,25.1 42.1,25.1\"></polyline>\n  <path fill=\"#FFFFFF\" d=\"M16.8,26.1V22h10.3c0.2,0.7,0.3,1.3,0.3,2.3c0,6.3-4.2,10.7-10.6,10.7c-6.1,0-11-4.9-11-11s4.9-11,11-11 c3,0,5.5,1.1,7.4,2.9l-3.1,3c-0.8-0.7-2.2-1.6-4.2-1.6c-3.6,0-6.6,3-6.6,6.7s3,6.7,6.6,6.7c4.2,0,5.8-2.9,6.1-4.6H16.8z\"></path>\n</svg>\n",
        popup: {width: 400, height: 500},
    },
    blogger: {
        text: 'Blogger',
        link: 'https://www.blogger.com/blog-this.g?u={url}&n={title}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#FF9800\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#F1F1F1\" d=\"M37.1,20.2h-1.2c-1,0-1.9-0.8-1.9-1.9c0-5.2-4.2-9.4-9.4-9.4h-6.2C13.2,9,9,13.2,9,18.4v11.2 c0,5.2,4.2,9.4,9.4,9.4h11.2c5.2,0,9.4-4.2,9.4-9.4v-7.5C39,21.1,38.2,20.2,37.1,20.2z M18.4,16.5h7.5c1,0,1.9,0.8,1.9,1.9 s-0.8,1.9-1.9,1.9h-7.5c-1,0-1.9-0.8-1.9-1.9S17.3,16.5,18.4,16.5z M29.6,31.5H18.4c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9h11.2 c1,0,1.9,0.8,1.9,1.9S30.7,31.5,29.6,31.5z\"></path>\n</svg>\n",
        popup: {width: 705, height: 455},
    },
    reddit: {
        text: 'Reddit',
        link: 'https://reddit.com/submit?url={url}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#CEE3F8\" width=\"100%\" height=\"100%\"></rect>\n  <circle fill=\"#FFFFFF\" cx=\"35.5\" cy=\"13.2\" r=\"2.5\"></circle>\n  <path fill=\"#FFFFFF\" d=\"M40.2,23.7c0-1.7-1.4-3.1-3.2-3.1c-1,0-1.9,0.5-2.5,1.2c-2.6-1.8-6.4-3-10.6-3s-7.9,1.1-10.6,2.9 c-0.6-0.7-1.5-1.1-2.4-1.1c-1.8,0-3.2,1.4-3.2,3.1c0,1.3,0.8,2.4,1.9,2.9C9.5,27,9.5,27.5,9.5,28c0,5.1,6.5,9.3,14.5,9.3 s14.5-4.1,14.5-9.3c0-0.5-0.1-0.9-0.2-1.4C39.4,26.2,40.2,25,40.2,23.7z\"></path>\n  <path fill=\"#000000\" d=\"M41,23.7c0-2.1-1.8-3.9-3.9-3.9c-1,0-1.9,0.4-2.6,1c-2.6-1.6-5.9-2.6-9.4-2.7l1.9-5.9l5.2,1.2c0.1,1.7,1.5,3.1,3.3,3.1 s3.3-1.4,3.3-3.2s-1.5-3.2-3.3-3.2c-1.3,0-2.4,0.8-3,1.9l-5.9-1.4c-0.4-0.1-0.8,0.1-0.9,0.5l-2.3,7c-3.8,0.1-7.3,1-10,2.7 c-0.7-0.6-1.6-0.9-2.5-0.9c-2.2,0-3.9,1.7-3.9,3.9c0,1.4,0.7,2.6,1.8,3.2c-0.1,0.4-0.1,0.7-0.1,1.1c0,2.7,1.6,5.3,4.6,7.2 C16.1,37,19.9,38,23.9,38s7.8-1,10.6-2.8c3-1.9,4.6-4.4,4.6-7.2c0-0.3,0-0.7-0.1-1C40.2,26.3,41,25.1,41,23.7z M35.5,11.5 c1,0,1.8,0.8,1.8,1.7c0,0.9-0.8,1.7-1.8,1.7s-1.8-0.8-1.8-1.7C33.7,12.3,34.5,11.5,35.5,11.5z M8.5,23.7c0-1.3,1.1-2.4,2.4-2.4 c0.5,0,0.9,0.1,1.2,0.3c-1.4,1.1-2.4,2.4-2.9,3.8C8.8,25,8.5,24.4,8.5,23.7z M33.7,33.9c-2.6,1.7-6.1,2.6-9.8,2.6s-7.2-0.9-9.8-2.6 c-2.5-1.6-3.9-3.7-3.9-5.9c0-0.2,0-0.3,0-0.5c0-0.5,0.2-1,0.3-1.4c0.5-1.2,1.3-2.3,2.6-3.3c0.3-0.2,0.6-0.5,0.9-0.7 c0.1-0.1,0.2-0.1,0.3-0.2c2.6-1.6,5.9-2.4,9.5-2.4s7,0.9,9.6,2.5l0.2,0.1c0.4,0.2,0.7,0.5,1,0.8c1.2,1,2,2.1,2.5,3.2 c0.2,0.5,0.3,1,0.3,1.4c0,0.2,0,0.3,0,0.5C37.6,30.2,36.3,32.3,33.7,33.9z M38.6,25.5c-0.5-1.4-1.5-2.7-2.9-3.8 c0.4-0.2,0.8-0.4,1.3-0.4c1.3,0,2.4,1.1,2.4,2.4C39.5,24.4,39.2,25.1,38.6,25.5z\"></path>\n  <path fill=\"#FF4500\" d=\"M18.9,23.9c-1.3,0-2.4,1.1-2.4,2.3s1.1,2.3,2.4,2.3s2.3-1,2.3-2.3S20.2,23.9,18.9,23.9z\"></path>\n  <path fill=\"#FF4500\" d=\"M29.1,23.9c-1.3,0-2.4,1.1-2.4,2.3c0,1.3,1.1,2.3,2.4,2.3s2.3-1,2.3-2.3S30.4,23.9,29.1,23.9z\"></path>\n  <path fill=\"#000000\" d=\"M29.5,31.7c-0.3-0.3-0.8-0.3-1.1,0C27.6,32.6,26.1,33,24,33s-3.6-0.4-4.4-1.3c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1 c1.2,1.1,3,1.7,5.5,1.7s4.3-0.6,5.5-1.7C29.8,32.5,29.8,32,29.5,31.7z\"></path>\n</svg>\n",
        popup: {width: 860, height: 770},
    },
    tumblr: {
        text: 'Tumblr',
        link: 'https://www.tumblr.com/widgets/share/tool?canonicalUrl={url}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#385874\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#FFFFFF\" d=\"M25.3,7v8.6h9.3v5.3h-9.3v8.7c0,2,0.1,3.2,0.3,3.8c0.2,0.6,0.6,1,1.2,1.3c0.8,0.5,1.7,0.7,2.7,0.7 c1.8,0,3.6-0.6,5.4-1.7v5.4c-1.5,0.7-2.9,1.2-4.1,1.4c-1.2,0.3-2.6,0.4-4,0.4c-1.6,0-3.1-0.2-4.3-0.6c-1.3-0.4-2.3-1-3.2-1.7 c-0.9-0.7-1.5-1.5-1.8-2.3s-0.5-2-0.5-3.6V20.9h-4v-4.8c1.4-0.4,2.6-1.1,3.6-1.9c1-0.8,1.8-1.8,2.4-2.9c0.6-1.1,1-2.6,1.2-4.3H25.3 z\"></path>\n</svg>\n",
        popup: {width: 600, height: 500},
    },
    vk: {
        text: 'VK',
        link: 'https://vk.com/share.php?url={url}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#42678E\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#FFFFFF\" d=\"M34.6,33.7h-0.2c-1.7-0.3-2.9-1.5-3.9-2.6c-0.6-0.6-1.4-2.1-2.5-1.9c-1.5,0.2-0.7,2.7-1.4,3.8 c-0.5,0.9-2.6,0.7-4.1,0.6c-4.6-0.5-6.9-2.9-9-5.5c-2.2-2.8-3.9-5.7-5.5-9C7.7,18,7,16.9,7,15.6c0.7-0.6,2-0.4,3.2-0.4 c1,0,2.7-0.2,3.4,0.2c0.5,0.2,0.9,1.4,1.3,2.2c0.8,1.8,1.6,3.1,2.6,4.5c0.4,0.6,1.1,1.8,1.9,1.7c0.8-0.2,0.8-2,0.9-3.2 c0-1.4,0-3.1-0.4-3.8c-0.4-0.7-1.1-0.7-1.8-1.1c0.6-1.2,2.2-1.3,4.1-1.3c1.6,0,3.8-0.2,4.5,0.9c0.6,1.1,0.2,3,0.2,4.4 c0,1.6-0.3,3.3,0.8,4c0.9-0.1,1.3-0.9,1.8-1.6c1.1-1.4,1.8-2.7,2.6-4.5c0.3-0.8,0.7-2.1,1.4-2.3c1-0.4,2.5-0.1,3.9-0.1 c1.2,0,3.2-0.3,3.6,0.5c0.3,0.7-0.6,2.3-0.9,2.8c-1.1,1.7-2.1,2.8-3.3,4.4c-0.5,0.6-1.4,1.6-1.4,2.5c0,0.7,0.8,1.3,1.4,1.8 c1.2,1.1,2.1,2,3.1,3.2c0.4,0.5,1.2,1.5,1.1,2.1C40.8,34.5,36.2,33.2,34.6,33.7z\"></path>\n</svg>\n",
        popup: {width: 650, height: 580},
    },
    linkedin: {
        text: 'LinkedIn',
        link: 'https://www.linkedin.com/shareArticle?url={url}&title={title}',
        svg: "<svg viewBox=\"0 0 48 48\">\n  <rect fill=\"#0080B2\" width=\"100%\" height=\"100%\"></rect>\n  <path fill=\"#FFFFFF\" d=\"M9.4,39h6.4V18.8H9.4V39z M12.6,9C10.4,9,9,10.5,9,12.5c0,1.9,1.4,3.5,3.6,3.5l0,0c2.2,0,3.6-1.6,3.6-3.5 C16.2,10.5,14.8,9,12.6,9z M31.6,18.3c-3.4,0-4.9,2-5.8,3.3v0.1l0,0v-0.1v-2.9h-6.4c0.1,1.9,0,20.2,0,20.2h6.4V27.7 c0-0.6,0-1.2,0.2-1.6c0.5-1.2,1.5-2.5,3.3-2.5c2.3,0,3.3,1.9,3.3,4.6V39H39V27.4C39,21.2,35.8,18.3,31.6,18.3z\"></path>\n</svg>\n",
        popup: {width: 550, height: 470},
    },
    email: {
        text: 'Email',
        link: 'mailto:?body={url}',
        svg: "<svg viewBox=\"0 0 24 24\">\n  <rect fill=\"#888\" width=\"100%\" height=\"100%\"/>\n  <path fill=\"#fff\" d=\"M21,8.5l-9,5l-9-5v-2l9,5l9-5 M20,5.5H4c-0.5,0-1,0.4-1,0.8v11.3c0,0.5,0.4,0.8,1,0.8H20c0.5,0,1-0.4,1-0.8V6.3 C21,5.9,20.6,5.5,20,5.5z\"/>\n</svg>\n\n",
    },
};

vjs.plugin('share', function(opt){
    var player = this;
    player.ready(function(){
        player.addChild('ShareButton', opt||{});
    });
});
var events = ['touchstart', 'touchend', 'click'];
var prevent_click = function(event){
    event.stopPropagation();
};
function get_top_url(){
    return window.top==window ? location.href : document.referrer;
}
var Button = vjs.getComponent('Button');
vjs.registerComponent('ShareButton', vjs.extend(Button, {
    controlText_: 'Share video',
    constructor: function(player, options){
        Button.call(this, player, options);
        this.on(events, prevent_click);
    },
    createEl: function(){
        var el = Button.prototype.createEl.apply(this, arguments);
        el.appendChild(vjs.createEl('div', {
            className: 'vjs-button-icon',
            innerHTML: "<svg fill=\"#FFF\" viewBox=\"0 0 24 24\">\n  <path d=\"M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z\"/>\n</svg>\n",
        }));
        return el;
    },
    buildCSSClass: function(){
        return 'vjs-share-button '+Button.prototype.buildCSSClass.call(this);
    },
    handleClick: function(event){
        var player = this.player_;
        var modal = player.addChild('shareDialog', this.options_);
        this.on(modal, 'dispose', function(){
            player.removeChild(modal);
            this.show();
        });
        modal.open();
        this.hide();
    },
}));
var ModalDialog = vjs.getComponent('ModalDialog');
vjs.registerComponent('ShareDialog', vjs.extend(ModalDialog, {
    constructor: function(player, options){
        ModalDialog.call(this, player, options);
        this.on(events, prevent_click);
        this.on(this.getChild('closeButton'), events, prevent_click);
        this.options_.fillAlways = false;
        this.hasBeenFilled_ = true;
        var el = this.contentEl_;
        el.appendChild(vjs.createEl('div', {
            className: 'vjs-share-dialog-title',
            innerHTML: this.localize('Share video'),
        }));
        var btns_el = vjs.createEl('div', {
            className: 'vjs-share-dialog-buttons',
        });
        el.appendChild(btns_el);
        this.contentEl_ = btns_el;
        var all_btns = Object.keys(services);
        var buttons = options.buttons || all_btns;
        var _this = this;
        buttons.forEach(function(b){
            if (all_btns.indexOf(b)==-1)
                return;
            _this.addChild('ShareLink', vjs.mergeOptions(_this.options_,
                {type: b}));
        });
        this.contentEl_ = el;
    },
    buildCSSClass: function(){
        return 'vjs-share-dialog '+
            ModalDialog.prototype.buildCSSClass.call(this);
    },
}));
var ClickableComponent = vjs.getComponent('ClickableComponent');
vjs.registerComponent('ShareLink', vjs.extend(ClickableComponent, {
    constructor: function(player, options){
        ClickableComponent.call(this, player, options);
        this.on(events, prevent_click);
        this.type_ = options.type;
        var item = services[this.type_];
        this.controlText(item.text);
        this.addClass('vjs-share-'+this.type_);
        var url = this.options_.url||get_top_url();
        this.href = item.link
            .replace('{url}', encodeURIComponent(url))
            .replace('{title}', encodeURIComponent(this.options_.title||''));
        this.link = vjs.createEl('a', {className: 'vjs-share-link',
            innerHTML: item.svg}, {target: this.type_!='email' ? '_blank' : '',
            href: this.href});
        this.link.addEventListener('touchstart', function(e){
            e.stopPropagation(); });
        this.link.addEventListener('click', this.on_click.bind(this));
        this.el_.appendChild(this.link);
    },
    on_click: function(e){
        var item = services[this.type_], popup;
        if (!(popup = item.popup))
            return;
        e.preventDefault();
        window.open(this.href, this.type_,'left=20,top=20,height='+
            popup.height+',width='+popup.width+',resizable=1');
    },
}));
